export default {
    path: '/lookup',
    name: 'LookupTool',
    meta: {
        title: 'Search',
        documentTitle: 'Lookup Tool',
        requiresAuth: true,
    },
    props: ( route ) => ( { query: route.query.q } ),
    component: () => import( /* webpackChunkName: "TitleGroupSearch" */ '@/views/Lookup/Lookup' ),
};
